export default `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 1024 1024">
    <path d="M512 0q138.935 0 256.857 68.61t186.533 186.533 68.61 256.857-68.61 256.857-186.533 186.533-256.857 68.61-256.857-68.61-186.533-186.533-68.61-256.857 68.61-256.857 186.533-186.533 256.857-68.61zM254.714 426.238v171.525h514.573v-171.525h-514.573z"></path>
</svg>
`;
